import FieldProto from "../../proto/field-proto"
import FieldString_View from "./render/view"
import FieldInputProto_ManagementPreview from "./render/management-preview"
import FieldString_FormElement from "./render/form-element"
import FieldString_FormElementView from "./render/form-element-view"
import FieldString_ManagementForm from "./render/management-form"
import FieldString_ViewSmall from "./render/view-small"
import FieldString_InlineEditable from "./render/inline-editable"
import {GROUP_TEXT} from "../../../gd/const/fields/field2-groups"
import FieldString_AutomationTrigger from "./render/automation-trigger"
import FieldString_AutomationConditionForm from "./render/automation-condition"
import FieldString_AutomationActionForm from "./render/automation-action"
import FieldString_Editable from "./render/editable/editable"
import {FieldFilterType} from "../../proto/types"
import FieldString_ConditionForm from "./render/condition"
import {FIELD_CONDITIONS_STRING, FieldString_filterFunc} from "../../conditions/string"

export default class FieldString extends FieldProto {

    FIELD_DEFAULT_WIDTH = 200

    // public trimValue: boolean

    constructor(config: any) {
        super(config);

        this.typeLabel = "String"
        this.typeGroup = GROUP_TEXT
        this.typeDescription = "Generic text input field"
        this.trimValue = _.get(config, 'trimValue', true)   // trim value in input forms

        this.filterType = FieldFilterType.STRING
        this.icon = config.icon || 'i5-text'

        this.isSearchable = true
        this.isFilterAvailable = true

        this.placeholder = _.get(config, 'placeholder', null)

        this.conditionTypes = FIELD_CONDITIONS_STRING

        // core/gd-form/common/form-manager
        this.formType = 'input'

        this.components = {}

        this.renderComponents.view                      = FieldString_View
        this.renderComponents.viewSmall                 = FieldString_ViewSmall
        this.renderComponents.inlineEditable            = FieldString_InlineEditable

        this.renderComponents.glistView                 = FieldString_ViewSmall

        this.renderComponents.managementPreview         = FieldInputProto_ManagementPreview
        this.renderComponents.managementForm            = FieldString_ManagementForm

        this.renderComponents.formElement               = FieldString_FormElement
        this.renderComponents.formElementView           = FieldString_FormElementView

        this.renderComponents.automationTriggerForm     = FieldString_AutomationTrigger
        this.renderComponents.automationConditionForm   = FieldString_AutomationConditionForm
        this.renderComponents.automationActionForm      = FieldString_AutomationActionForm
        this.renderComponents.editable                  = FieldString_Editable

        this.renderComponents.conditionForm             = FieldString_ConditionForm
        this.renderComponents.filterForm                = FieldString_ConditionForm

        this.filterFunc                                 = FieldString_filterFunc
    }

    /*** DATA FUNCTIONS ***/

    sortValue(value: any) {
        return value ? value.toLowerCase() : ''
    }

    searchValue(value: any) {
        return value ? value.toLowerCase() : ''
    }

    /*listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [(listItem:any) => this.getViewValue(listItem.item)],
            directions  : [sort]
        }
    }*/
}
